import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'components/ui/atoms/button';
import { Icon } from 'components/ui/atoms/icons';
import { SupportLink } from 'components/ui/atoms/link';
import { getEnvOrFail } from 'env/env';
import { OrderAbout } from './components';
import { messages } from './messages';

export const ThankYouPending = () => {
  const { formatMessage } = useIntl();
  const learnerDashboardUrl = getEnvOrFail(
    'NEXT_PUBLIC_EDX_LEARNER_DASHBOARD_URL',
  );

  return (
    <>
      <div className="container-fluid py-5 bg-light-200 px-md-5">
        <div className="row justify-content-center">
          <section className="col-12 col-md-8 p-0">
            <div className="d-flex align-items-center">
              <Icon
                type="timelapse"
                svgProps={{
                  'aria-label': 'Hourglass',
                  className: 'mr-2 text-info-500',
                }}
              />
              <div className="h-5 text-info-500 mb-0">
                {formatMessage(messages['payment.thankyou.pending.subheading'])}
              </div>
            </div>
            <h1 className="mt-4 tw-text-3.5xl">
              {formatMessage(messages['payment.thankyou.pending.heading'])}
            </h1>
            <p className="tw-mb-4">
              {formatMessage(messages['payment.thankyou.pending.body'])}{' '}
              {formatMessage(
                messages['payment.thankyou.pending.body.confirmation'],
              )}
            </p>
            <div className="tw-flex tw-gap-2">
              <Button variant="brand" radius="none" asChild>
                <a href={learnerDashboardUrl}>
                  {formatMessage(
                    messages['payment.thankyou.pending.dashboard'],
                  )}
                </a>
              </Button>
            </div>
          </section>
        </div>
      </div>
      <div className="container-fluid px-md-5 py-4">
        <div className="row justify-content-center py-4">
          <section className="col-12 col-md-8 rounded border py-3">
            <OrderAbout />
          </section>
        </div>
        <div className="row justify-content-center py-4">
          <section className="col-12 col-md-8">
            <p className="mb-0">
              <FormattedMessage
                id="payment.thankyou.pending.support"
                defaultMessage="Payment still not confirmed after a few minutes? Please {supportLink}."
                description="Guidance to contact support if the payment stays unconfirmed"
                values={{ supportLink: <SupportLink /> }}
              />
            </p>
          </section>
        </div>
      </div>
    </>
  );
};
